import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { parseFeatureQuery as e } from "./pbfFeatureServiceParser.js";

function t(t, r) {
  var u = e(t, r),
      o = u.queryResult.featureResult,
      s = u.queryResult.queryGeometry,
      y = u.queryResult.queryGeometryType;

  if (o && o.features && o.features.length && o.objectIdFieldName) {
    var _e = o.objectIdFieldName;

    var _iterator = _createForOfIteratorHelper(o.features),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;
        _t.attributes && (_t.objectId = _t.attributes[_e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o && (o.queryGeometry = s, o.queryGeometryType = y), o;
}

export { t as parsePBFFeatureQuery };